import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import {DataGridColumn} from "../queries/queries.models";

export interface ViewQueryConfigurationModel {
    uri: string;
    title?: string;
    entityType?: EntityTypes;
    onRowSelected?: (item) => string;
    settings?: any;
    queryHeaderViewModel?: string
    onColumnPushed?: ((column: DataGridColumn) => void);
    onColumnsPrepared?: ((columns: DataGridColumn[]) => void);
    sortAlphabetically?: boolean;
    clickMode?: string;
    getParams?: (item: any) => any;
    selectionMode?: 'none' | 'single' | 'multiple';
}

export const AllViewQueryConfigurationConstants: ViewQueryConfigurationModel[] = [
    {
        title: "Genesis Examples",
        uri: "GenesisExample",
        entityType: EntityTypes.GenesisExample,
        sortAlphabetically: true,
    }
];
